/* global headerBarCarouselAnimationTime */
jQuery(document).ready(function ($) {
  const animationTime = typeof headerBarCarouselAnimationTime === 'number' ? headerBarCarouselAnimationTime : 0;
  if (animationTime === 0) {
    return;
  }

  const items = $('.header-info-bar-item');
  const itemsCount = items.length;

  let index = 0;
  setInterval(() => {
    items.slideUp();
    $($('.header-info-bar-item')[index]).slideDown();
    index++;
    if (index === itemsCount) {
      index = 0;
    }
  }, animationTime)
});
